import instance from "http/Manager";
import { headers } from "http/Settings";

export const get_whitepaper = () => {
  return instance.get(`/v1/mngr/whitepaper`, { headers });
};

export const post_whitepaper = (data) => {
  return instance.post(`/v1/mngr/whitepaper`, data, {
    headers: { ...headers, "Content-Type": "multipart/form-data" },
  });
};

export const put_whitepaper = (data) => {
  return instance.put(`/v1/mngr/whitepaper`, data, {
    headers: { ...headers, "Content-Type": "multipart/form-data" },
  });
};

export const delete_whitepaper = (id) => {
  return instance.delete(`/v1/mngr/whitepaper/${id}`, { headers });
};
